var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "current",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Formatting / italic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.81992 7.25H10.3199L8.66992 14.75H7.16992L8.81992 7.25ZM10.0799 4.25C9.93159 4.25 9.78658 4.29399 9.66324 4.3764C9.53991 4.45881 9.44378 4.57594 9.38701 4.71299C9.33025 4.85003 9.31539 5.00083 9.34433 5.14632C9.37327 5.2918 9.4447 5.42544 9.54959 5.53033C9.65448 5.63522 9.78812 5.70665 9.9336 5.73559C10.0791 5.76453 10.2299 5.74968 10.3669 5.69291C10.504 5.63614 10.6211 5.54001 10.7035 5.41668C10.7859 5.29334 10.8299 5.14834 10.8299 5C10.8299 4.80109 10.7509 4.61032 10.6103 4.46967C10.4696 4.32902 10.2788 4.25 10.0799 4.25Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.34485d002747cd97a491a3aa6d1391a4.svg";
export { ForwardRef as ReactComponent };